import React from "react"

export default class UserMessagePlayer extends React.Component {
	
	constructor(props) {
		super(props);

		this.state = {
			messageQueue: []
		};
	}

	componentDidMount() {
		//console.log('UserMessagePlayer componentDidMount', this.props.messages);
		var messageQueue = [];

		if (this.props.user_messages && this.props.user_messages.length) {
			for (var i = 0, ilen = this.props.user_messages.length; i < ilen; i++) {
				var user_message = this.props.user_messages[i];

				if (user_message && user_message.opened_at) {
					//console.log('ALREADY OPENED, DO NOT DISPLAY');
				} else if (user_message.deliver_at && moment(user_message.deliver_at).isSameOrBefore(new Date())) {
					//console.log('DELIVER AT VALID', user_message.deliver_at);
					messageQueue.push(user_message);
				} else if (user_message.deliver_at_login_count && this.props.user_login_count >= user_message.deliver_at_login_count) {
					//console.log('DELIVER AT LOGIN COUNT VALID', user_message.deliver_at_login_count, this.props.user_login_count);
					messageQueue.push(user_message);
				} else {
					//console.log('DO NOT DELIVER YET', user_message, this.props.user_login_count);
				}
			}

			this.setState({messageQueue: messageQueue});
		}
	}

	componentDidUpdate() {
		var self = this;
		
		//console.log('UserMessagePlayer componentDidUpdate', this.state.messageQueue);

		if (this.state.messageQueue && this.state.messageQueue.length) {
			for (var i = 0, ilen = this.state.messageQueue.length; i < ilen; i++) {
				var message = this.state.messageQueue[i];
				bootbox.alert({
			    size: "large",
			    title: message.subject,
			    message: message.body,
			    callback: function() { 
			    	self.markMessageAsOpened(message);

			    	var messageQueue = [];
			    	for (var j = 0, jlen = self.state.messageQueue.length; j < jlen; j++) {
			    		if (self.state.messageQueue[j].id != message.id) {
			    			messageQueue.push(self.state.messageQueue[j]);
			    		}
			    	}
			    	//console.log('messageQueue', messageQueue);
			    	self.setState({messageQueue: messageQueue});
			    	//self.forceUpdate();
			    }
				});
				break;
				//}
			}
		}
	}
 
	render() {
		return null;
	}

	markMessageAsOpened(message) {
    $.ajax({
      type: 'POST',
      url: this.props.mark_message_as_opened_path,
      data: {
      	message_id: message.id,
      	user_id: this.props.user_id,
      },
    }).done(function (data) {
    	//console.log('markMessageAsOpened done', data);
    });
	}

}